import React from 'react'
import libraryBooksIcon from '../../assets/icons/library_books.png'

const LibraryBooksIcon = ({ size = 24, style = {} }) => {
  return (
    <img 
      src={libraryBooksIcon} 
      alt="Library Books" 
      width={size} 
      height={size}
      style={{ 
        display: 'inline-block',
        verticalAlign: 'middle',
        ...style 
      }}
    />
  )
}

export default LibraryBooksIcon
